(function () {
  const roots = document.querySelectorAll("[data-product-accordion]");
  if (!roots.length) return;

  roots.forEach((root) => {
    const singleOpen = root.getAttribute("data-single-open") === "true";
    const openFirst = root.getAttribute("data-open-first") === "true";
    const triggers = root.querySelectorAll("[data-acc-trigger]");

    const closeItem = (trigger) => {
      const panelId = trigger.getAttribute("aria-controls");
      const panel = root.querySelector("#" + CSS.escape(panelId));
      if (!panel) return;

      trigger.setAttribute("aria-expanded", "false");
      panel.classList.add("tw-hidden");
      panel.classList.remove("tw-block");

      const icon = trigger.querySelector("[data-acc-icon]");
      if (icon) icon.classList.remove("tw-rotate-180");
    };

    const openItem = (trigger) => {
      const panelId = trigger.getAttribute("aria-controls");
      const panel = root.querySelector("#" + CSS.escape(panelId));
      if (!panel) return;

      trigger.setAttribute("aria-expanded", "true");
      panel.classList.remove("tw-hidden");
      panel.classList.add("tw-block");

      const icon = trigger.querySelector("[data-acc-icon]");
      if (icon) icon.classList.add("tw-rotate-180");
    };

    let anyOpen = false;

    triggers.forEach((t) => {
      if (t.getAttribute("aria-expanded") === "true") {
        anyOpen = true;
        openItem(t);   // force correct classes + icon
      } else {
        closeItem(t);  // ensure closed panels really close
      }
    });

    if (openFirst && !anyOpen && triggers.length) {
      openItem(triggers[0]);
      if (singleOpen) {
        triggers.forEach((t, i) => { if (i !== 0) closeItem(t); });
      }
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const isOpen = trigger.getAttribute("aria-expanded") === "true";

        if (singleOpen) {
          triggers.forEach((t) => closeItem(t));
          if (!isOpen) openItem(trigger);
        } else {
          if (isOpen) closeItem(trigger);
          else openItem(trigger);
        }
      });
    });
  });
})();
